/**
 * 资料片专题「开疆拓土」各内页的 CMS 接入常量（来自 CMS 后台配置）。
 *
 * 路由借鉴上一届：/list/:id 的 id 即文章 articleId（如 /list/11935），
 * list 页按 articleId switch 渲染对应内页，内页 store 用对应 articleId 拉取 CMS 正文。
 */

// CMS 栏目位 ID（本届统一）
export const CMS_CATEGORY_ID = '7872';

// CMS 接口地址
export const CMS_API = 'https://jxsj.xoyo.com/api.php';

// 各内页文章 ID（= 路由 /list/:id 的 id）
export const ARTICLE_ID = {
  // 战域领土 荣耀嘉奖
  BATTLE_TERRITORY: 11935,
  // 减负调优 轻松武侠
  BURDEN_OPTIMIZATION: 11936,
  // 福利狂欢 金币66600
  WELFARE_CARNIVAL: 11937,
  // 预约新服 百万绑金
  RESERVE_SERVER: 11938,
  // 天下第一 帮会巅峰（暂无内页，点击仅提示敬请期待）
  TOP_ONE: 11939
};

// 各内页导航名称（埋点 clickMenu 的 title 单一来源，供首页/内页导航复用，避免各处 data-name 文案不一致）
export const ARTICLE_TITLE = {
  [ARTICLE_ID.BATTLE_TERRITORY]: '战域领土 荣耀嘉奖',
  [ARTICLE_ID.BURDEN_OPTIMIZATION]: '减负调优 轻松武侠',
  [ARTICLE_ID.WELFARE_CARNIVAL]: '福利狂欢 金币66600',
  [ARTICLE_ID.RESERVE_SERVER]: '预约新服 百万绑金',
  [ARTICLE_ID.TOP_ONE]: '天下第一 帮会巅峰'
};
